import { handleApiResponse } from "../utils/apiUtils";
import secureApi from "./secureApi";

export const blockUser = (targetUserId) =>
  handleApiResponse(() => secureApi.post(`/api/chats/block/${targetUserId}`));

export const unblockUser = (targetUserId) =>
  handleApiResponse(() => secureApi.delete(`/api/chats/block/${targetUserId}`));

export const getBlockList = () =>
  handleApiResponse(() => secureApi.get("/api/chats/block"));

// Issue #126: ブロック一覧画面用（表示用のユーザー情報付き）
export const getBlockedUsers = () =>
  handleApiResponse(() => secureApi.get("/api/chats/block/users"));
